import type { FunctionComponent } from "react";
import { FixedPayoutModalPartial } from "../../../../partials/admin/menus/fixed-payout/fixed-payout-modal.admin.partials";

export const FixedPayoutModalAdminScreen: FunctionComponent = () => {
    return <FixedPayoutModalPartial />;
};
